import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Button, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import tick_gray from "../../../assets/images/chats/gray_light.svg";
import tick_green from "../../../assets/images/chats/double-tick_green.svg";
import { createStyledIndicatorButton } from "../../../common/StyledComponents/SideBarComponents";
import { useTranslation } from "react-i18next";

import { crossIcon, crossIconDiv } from "../../../assets/commonFunction";
import { fetchMessageRecipients, handleFetchConversation } from "../../../appStore/actions/ArkchatGroup/action";
const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};

const RecipientList = ({
  recipientList,
  setRecipientListOpen,
  readby,
  handleShowUserProfile,
  pnId,
  tempTimetoken,
  compact,
  senderId,
}) => {
  const dispatch = useDispatch();
  // A message to everyone comes without its recipient list (compact): load
  // it here, a page at a time, each with whether they've read it.
  const [loaded, setLoaded] = useState({ list: [], total: 0, page: 0, loading: false });
  const loadPage = (page) => {
    setLoaded((prev) => ({ ...prev, loading: true }));
    dispatch(fetchMessageRecipients(pnId, tempTimetoken, page)).then((data) => {
      setLoaded((prev) => ({
        list: data ? (page === 1 ? data.recipients : [...prev.list, ...data.recipients]) : prev.list,
        total: data ? data.total : prev.total,
        page: data ? page : prev.page,
        loading: false,
      }));
    });
  };
  useEffect(() => {
    if (compact && pnId && tempTimetoken) loadPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [compact, pnId, tempTimetoken]);
  // In a big group the apps aren't told of every read (only the people
  // whose messages were read are), so the ticks on the message held here can
  // be behind: when the list opens, show the message's current ones.
  const [currentReadBy, setCurrentReadBy] = useState(null);
  useEffect(() => {
    if (compact || !pnId || !tempTimetoken) return undefined;
    let cancelled = false;
    dispatch(handleFetchConversation({ pn_id: pnId, timetoken: [tempTimetoken] })).then((res) => {
      const latest = Array.isArray(res) ? res[0]?.message?.read_by : null;
      if (!cancelled && Array.isArray(latest)) setCurrentReadBy(latest);
    });
    return () => {
      cancelled = true;
    };
  }, [dispatch, pnId, tempTimetoken, compact]);
  const shownReadBy = currentReadBy || readby;
  const rows = compact ? loaded.list : recipientList;
  const isRead = (item) => (compact ? item?.read === true : shownReadBy?.includes(item?.id));
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const NameBadge = createStyledIndicatorButton("#E3E1E1");
  return (
    <Box sx={classes?.drawerBody}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={classes.header}
      >
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography sx={classes.iconDiv}>
            <CloseIcon
              sx={classes.iconn}
              onClick={() => setRecipientListOpen(false)}
            />
          </Typography>
          <Typography color={"black"}>Message Recipients</Typography>
        </Stack>
      </Stack>

      <Box>
        <Box padding="0px 19px 0px 12px">
          <Typography variant="caption" color={"black"}>
            {appContent?.KEY251}
          </Typography>
        </Box>
        {rows?.map((item) => (
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            padding="11px"
            key={item?.id + "recipientList"}
          >
            <NameBadge
              onClick={() => handleShowUserProfile(item?.id)}
              sx={{
                color: "#183243",
                padding: item?.pp && "0px",
                overflow: "hidden",
              }}
              size="small"
              variant="contained"
            >
              {item?.pp ? (
                <img src={item?.pp} alt="profile" height="100%" />
              ) : (
                <Typography color={"#183243"} fontSize={"0.75rem"}>
                  {item?.name && item?.name[0]}
                </Typography>
              )}
            </NameBadge>
            <Typography color={"#183243"} fontSize={"0.75rem"}>
              {item?.name}
            </Typography>
            {/* Who read it: not for the person who sent it. Both ticks are drawn at one size (the images differ). */}
            {String(item?.id) !== String(senderId) && (
              <Box>
                <img
                  src={isRead(item) ? tick_green : tick_gray}
                  alt="sent"
                  style={{ width: "12px", height: "auto", display: "block" }}
                />
              </Box>
            )}
          </Stack>
        ))}
        {compact && loaded.list.length < loaded.total && (
          <Box padding="11px">
            <Button size="small" disabled={loaded.loading} onClick={() => loadPage(loaded.page + 1)}>
              {loaded.loading ? "Loading..." : `Show more (${loaded.total - loaded.list.length})`}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default RecipientList;
